import { render, staticRenderFns } from "./WorkflowBuilder.vue?vue&type=template&id=be2fac90&scoped=true"
import script from "./WorkflowBuilder.vue?vue&type=script&lang=js"
export * from "./WorkflowBuilder.vue?vue&type=script&lang=js"
import style0 from "./WorkflowBuilder.vue?vue&type=style&index=0&id=be2fac90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2fac90",
  null
  
)

export default component.exports